import axios from "../axios";
import baseConstant from "../constants/base-constant";

const request = {
    sendVerifyCode(data = {}) {
        let url = baseConstant.REQ_AUTH_LOGIN_VERIFY_SEND;
        return axios.request({
            url,
            data
        })
    },
    loginByVerify(data = {}) {
        let url = baseConstant.REQ_AUTH_LOGIN_BY_VERIFY;
        return axios.request({
            url,
            data
        })
    },
    getWxOpenId(data = {}) {
        let url = baseConstant.REQ_WEIXIN_OPEN_ID_GET;
        return axios.request({
            url,
            data
        })
    },
    getMemberInfo(data = {}) {
        let url = baseConstant.REQ_MEMBER_INFO_GET;
        return axios.request({
            url,
            data
        })
    },
    getCityList(data = {}) {
       
        let url = baseConstant.REQ_MOVIE_CITY_LIST;
        return axios.request({
            url,
            data,
        });
    },
    getCountyList(data = {}) {
        let url = baseConstant.REQ_MOVIE_COUNTY_LIST;
        return axios.request({
            url,
            data
        })
    },
    doOrderPay(data = {}) {
        let url = baseConstant.REQ_ORDER_PAY;
        return axios.request({
            url,
            data
        });
    }
};

export default request;